import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  nav_item: "home",
};

export const NavBarSlice = createSlice({
  name: "navItem",
  initialState,
  reducers: {
    setNav_Item: (state, action) => {
      state.nav_item = action.payload;
    },
  },
});

export const { setNav_Item } = NavBarSlice.actions;

export default NavBarSlice.reducer;
